// variant-savings.js

// Money formatting
function formatMoney(cents) {
  try {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, "{{ shop.money_format | escape }}");
    }
  } catch (e) {}
  return (cents / 100).toFixed(2);
}

function renderSavings(el, variant) {
  if (!el) return;
  if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
    var saving = variant.compare_at_price - variant.price; // cents
    var pct = Math.round((saving * 100) / variant.compare_at_price);
    el.innerHTML = 'You save ' + pct + '% (<span class="money">' + formatMoney(saving) + '</span>)';
    el.hidden = false;
  } else {
    el.hidden = true;
  }
}

function findSavingsEl(root) {
  // If there are multiple product blocks, scope to nearest container if possible
  if (root && root.closest) {
    var scoped = root.closest('section, .product, .product__info, form[action*="/cart/add"]');
    if (scoped) {
      var el = scoped.querySelector('[data-variant-savings]');
      if (el) return el;
    }
  }
  return document.querySelector('[data-variant-savings]');
}

function getProductJSON() {
  var jsonEl = document.getElementById('variant-savings-json');
  if (!jsonEl) return null;
  try { return JSON.parse(jsonEl.textContent); } catch (e) { return null; }
}

function getSelectedVariantFromPage(product) {
  if (!product || !product.options || !product.variants) return null;

  // Build selected options in the same order as product.options
  var selected = product.options.map(function(optName) {
    var select = document.querySelector('select[name="options[' + optName + ']"]');
    if (select) return select.value;

    var radios = document.querySelectorAll('input[name="options[' + optName + ']"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return radios[i].value;
    }
    return null;
  });

  if (selected.some(function(v){ return v === null; })) {
    // Couldn’t read options (custom UI?), fall back to first available
    var fav = product.variants.find(function(v){ return v.available; });
    return fav || product.variants[0];
  }

  // Match variant by options
  var match = product.variants.find(function(v){
    if (!v.options) return false;
    for (var i = 0; i < v.options.length; i++) {
      if (v.options[i] !== selected[i]) return false;
    }
    return true;
  });

  return match || product.variants[0];
}

// Handle themes that dispatch a variant change event (Dawn & many OS2.0 themes)
document.addEventListener('variant:change', function(evt) {
  if (!evt.detail || !evt.detail.variant) return;
  var el = findSavingsEl(evt.target);
  renderSavings(el, evt.detail.variant);
});

// Fallback: listen to option changes and resolve variant ourselves
(function(){
  var product = getProductJSON();
  function onOptionsChange(e) {
    if (!e.target.matches('[name^="options"]')) return;
    if (!product) product = getProductJSON();
    var v = getSelectedVariantFromPage(product);
    var el = findSavingsEl(e.target);
    renderSavings(el, v);
  }
  document.addEventListener('change', onOptionsChange);

  // Initial paint (ensure it’s correct on first load)
  document.addEventListener('DOMContentLoaded', function() {
    if (!product) product = getProductJSON();
    var el = document.querySelector('[data-variant-savings]');
    if (el && product) {
      var v = getSelectedVariantFromPage(product);
      renderSavings(el, v);
    }
  });
})();
